import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityOrderAdjustNextRunDatesTemplate } from "themes/application/facility-order/pages";
import { FacilityOrderAdjustNextRunDatesViewStore } from "application/facility-order/stores";

@setCurrentView(rootStore => new FacilityOrderAdjustNextRunDatesViewStore(rootStore), "facilityOrderAdjustNextRunDatesViewStore")
@observer
class FacilityOrderAdjustNextRunDates extends React.Component {
    render() {
        return <FacilityOrderAdjustNextRunDatesTemplate {...this.props} />;
    }
}

export default FacilityOrderAdjustNextRunDates;